var _circle, _g, _circle2, _rect, _rect2, _g2, _path, _path2, _path3, _path4, _path5, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmptyState = function SvgEmptyState(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 361,
    height: 276,
    viewBox: "0 0 361 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.42,
    cx: 187.829,
    cy: 137.558,
    r: 137.558,
    fill: "#C5CEFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2706_16877)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.4199,
    y: 98,
    width: 237.531,
    height: 79.9382,
    rx: 16.7331,
    fill: "white"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.105,
    cy: 137.969,
    r: 19.4136,
    fill: "#C9D0F4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 141.506,
    y: 123.125,
    width: 33.1172,
    height: 10.2778,
    rx: 5.13888,
    fill: "#CFD5F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 141.377,
    y: 142.383,
    width: 76.5123,
    height: 10.2778,
    rx: 5.13888,
    fill: "#CFD5F7"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2706_16877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.2344 114.413C60.7888 102.587 71.6356 94.2601 83.4614 95.8144C95.2872 97.3688 103.614 108.216 102.06 120.041C100.505 131.867 89.6584 140.194 77.8325 138.64C66.0067 137.085 57.68 126.238 59.2344 114.413Z",
    fill: "#7C4DFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8075 94.2154C78.1735 94.0797 78.8956 94.1628 79.0862 94.576C79.2487 94.9283 79.3882 95.5223 79.3958 95.3957C79.4141 95.1144 79.3775 94.5059 79.5003 94.1879C79.5895 93.9561 79.7649 93.7381 80.0234 93.661C80.2407 93.5955 80.4961 93.5726 80.7218 93.6191C80.9605 93.6679 81.2113 93.8379 81.3051 93.9996C81.5811 94.4746 81.5857 95.4476 81.5987 95.3957C81.6475 95.1883 81.652 94.4586 81.8145 94.1879C81.922 94.0087 82.1934 93.8486 82.3383 93.8227C82.5625 93.783 82.8385 93.7708 83.0733 93.8166C83.2632 93.854 83.5201 94.0789 83.5895 94.1879C83.7565 94.4502 83.8503 95.1914 83.8785 95.4521C83.8907 95.5597 83.9349 95.1525 84.1019 94.8909C84.4115 94.4037 85.508 94.3092 85.5491 95.3782C85.569 95.8768 85.5644 95.854 85.5644 96.1895C85.5644 96.5829 85.5552 96.8208 85.5339 97.106C85.511 97.4102 85.4454 98.1003 85.3501 98.4343C85.2846 98.6638 85.0672 99.18 84.8522 99.4895C84.8522 99.4895 84.0333 100.443 83.9441 100.871C83.8549 101.3 83.8846 101.304 83.8663 101.607C83.8488 101.911 83.9586 102.311 83.9586 102.311C83.9586 102.311 83.3478 102.39 83.0177 102.337C82.7195 102.289 82.3505 101.696 82.2552 101.515C82.124 101.265 81.8442 101.313 81.7352 101.497C81.5644 101.789 81.1945 102.313 80.9345 102.346C80.4244 102.41 79.3676 102.369 78.5403 102.361C78.5403 102.361 78.6814 101.59 78.3672 101.326C78.1347 101.127 77.7343 100.728 77.4949 100.517L76.8605 99.8151C76.6447 99.5406 76.0965 99.1068 75.9127 98.3016C75.7503 97.5879 75.7663 97.2379 75.941 96.952C76.1179 96.6615 76.4518 96.5029 76.5921 96.4754C76.7507 96.4434 77.1198 96.4457 77.2593 96.5227C77.4293 96.6165 77.498 96.6439 77.6314 96.8208C77.8068 97.0549 77.8693 97.1685 77.7938 96.9131C77.7359 96.7133 77.5483 96.4594 77.4629 96.1735C77.3798 95.8982 77.1571 95.4544 77.1731 95.0099C77.1792 94.8414 77.2517 94.422 77.8075 94.2154Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8075 94.2154C78.1735 94.0797 78.8956 94.1628 79.0862 94.576C79.2487 94.9283 79.3882 95.5223 79.3958 95.3957C79.4141 95.1144 79.3775 94.5059 79.5003 94.1879C79.5895 93.9561 79.7649 93.7381 80.0234 93.661C80.2407 93.5955 80.4961 93.5726 80.7218 93.6191C80.9605 93.6679 81.2113 93.8379 81.3051 93.9996C81.5811 94.4746 81.5857 95.4476 81.5987 95.3957C81.6475 95.1883 81.652 94.4586 81.8145 94.1879C81.922 94.0087 82.1934 93.8486 82.3383 93.8227C82.5625 93.783 82.8385 93.7708 83.0733 93.8166C83.2632 93.854 83.5201 94.0789 83.5895 94.1879C83.7565 94.4502 83.8503 95.1914 83.8785 95.4521C83.8907 95.5597 83.9349 95.1525 84.1019 94.8909C84.4115 94.4037 85.508 94.3092 85.5491 95.3782C85.569 95.8768 85.5644 95.854 85.5644 96.1895C85.5644 96.5829 85.5552 96.8208 85.5339 97.106C85.511 97.4102 85.4454 98.1003 85.3501 98.4343C85.2846 98.6638 85.0672 99.18 84.8522 99.4895C84.8522 99.4895 84.0333 100.443 83.9441 100.871C83.8549 101.3 83.8846 101.304 83.8663 101.607C83.8488 101.911 83.9586 102.311 83.9586 102.311C83.9586 102.311 83.3478 102.39 83.0177 102.337C82.7195 102.289 82.3505 101.696 82.2552 101.515C82.124 101.265 81.8442 101.313 81.7352 101.497C81.5644 101.789 81.1945 102.313 80.9345 102.346C80.4244 102.41 79.3676 102.369 78.5403 102.361C78.5403 102.361 78.6814 101.59 78.3672 101.326C78.1347 101.127 77.7343 100.728 77.4949 100.517L76.8605 99.8151C76.6447 99.5406 76.0965 99.1068 75.9127 98.3016C75.7503 97.5879 75.7663 97.2379 75.941 96.952C76.1179 96.6615 76.4518 96.5029 76.5921 96.4754C76.7507 96.4434 77.1198 96.4457 77.2593 96.5227C77.4293 96.6165 77.498 96.6439 77.6314 96.8208C77.8068 97.0549 77.8693 97.1685 77.7938 96.9131C77.7359 96.7133 77.5483 96.4594 77.4629 96.1735C77.3798 95.8982 77.1571 95.4544 77.1731 95.0099C77.1792 94.8414 77.2517 94.422 77.8075 94.2154V94.2154Z",
    stroke: "black",
    strokeWidth: 0.57187,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1396 100.085V97.4476",
    stroke: "black",
    strokeWidth: 0.57187,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.603 100.094L81.5908 97.4458",
    stroke: "black",
    strokeWidth: 0.57187,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0808 97.47L80.0968 100.082",
    stroke: "black",
    strokeWidth: 0.57187,
    strokeLinecap: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd_2706_16877)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 273.284,
    y: 51.3677,
    width: 78.8305,
    height: 77.3432,
    rx: 19.3358,
    transform: "rotate(-6.35459 273.284 51.3677)",
    fill: "white",
    fillOpacity: 0.66,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.326 85.249L307.753 84.4219L302.988 74.6918L300.326 85.249ZM309.5 93.7831L311.641 93.3097C311.744 93.2982 311.867 93.2323 312.01 93.1119L311.95 92.5703L308.63 85.969L299.888 86.9426L298.101 94.1126L298.127 94.3447C298.139 94.4478 298.227 94.5424 298.394 94.6283L298.402 94.7057C298.408 94.7572 298.463 94.7773 298.566 94.7658L298.643 94.7572L300.835 94.748L301.016 96.3727L293.512 97.2085L293.331 95.5838L295.454 94.9557L301.517 69.9211L304.457 69.5937L315.956 91.9676C315.973 92.1223 315.987 92.2512 315.999 92.3544C316.056 92.4002 316.088 92.4489 316.093 92.5005C316.26 92.5864 316.368 92.6265 316.42 92.6208C316.523 92.6093 316.606 92.6523 316.669 92.7497L318.397 92.7922L318.578 94.4169L309.681 95.4077L309.5 93.7831ZM330.693 82.807C328.991 83.4665 327.754 84.0743 326.98 84.6304C326.378 84.8541 325.911 85.1149 325.579 85.413C325.241 85.6596 324.952 85.8745 324.711 86.058C323.955 87.2388 323.617 88.1902 323.697 88.9123C323.72 89.1186 323.832 89.4195 324.033 89.8148C324.279 90.1529 324.414 90.4251 324.437 90.6314C324.506 90.7804 324.598 90.9007 324.712 90.9924C324.93 91.0726 325.099 91.1843 325.219 91.3275C325.386 91.4135 325.552 91.4994 325.718 91.5853C325.936 91.6655 326.174 91.6912 326.432 91.6625C326.896 91.6108 327.308 91.5648 327.669 91.5246C328.185 91.4672 328.638 91.3123 329.028 91.0601C329.412 90.7562 329.752 90.5355 330.05 90.3979C330.348 90.2603 330.595 90.1284 330.79 90.0023C330.979 89.8246 331.194 89.644 331.434 89.4605L330.693 82.807ZM333.443 77.253L333.942 79.6255L335.096 89.9926C335.108 90.0957 335.18 90.2705 335.312 90.5169C335.495 90.7576 335.744 90.8865 336.06 90.9036L337.839 90.7054L338.011 92.2527L332.286 92.8903L331.581 90.7758C330.922 91.4235 330.274 91.9395 329.638 92.3236C329.552 92.4898 329.409 92.6102 329.209 92.6848C329.06 92.7536 328.913 92.8482 328.77 92.9686C328.432 93.2151 328.083 93.3585 327.722 93.3987C327.234 93.714 326.862 93.886 326.604 93.9147C326.409 94.0409 326.054 94.1327 325.538 94.1901C325.022 94.2475 324.498 94.2276 323.965 94.1303C322.355 93.7353 321.268 92.8902 320.706 91.5952C320.328 91.0107 320.113 90.4864 320.061 90.0222L319.941 88.939C319.918 88.7327 319.943 88.4949 320.018 88.2255C320.138 87.8988 320.273 87.4661 320.421 86.9273C320.777 86.3656 321.126 85.9873 321.47 85.7923C321.756 85.5515 322.043 85.3108 322.329 85.07C322.616 84.8292 322.983 84.6056 323.43 84.3992C323.922 84.1354 324.392 83.9004 324.839 83.6939C325.332 83.4302 325.856 83.2151 326.412 83.0488C327.002 82.722 327.624 82.4439 328.277 82.2145C328.931 81.9851 329.681 81.6926 330.53 81.3371L330.366 79.8671C330.211 78.4745 329.818 77.5261 329.187 77.0219C328.351 76.5407 327.571 76.3404 326.849 76.4208L325.534 76.5672C325.224 76.6017 324.769 76.7308 324.167 76.9544C324.024 77.0748 323.878 77.1694 323.729 77.2382L324.099 80.565L320.927 80.9182L320.428 80.6605C320.423 80.6089 320.368 80.5888 320.265 80.6003C320.214 80.6061 320.13 80.5631 320.016 80.4714L319.956 79.9299C319.852 79.0015 320.01 78.3051 320.428 77.8408C320.645 77.4511 320.898 77.1358 321.184 76.895C321.471 76.6542 321.78 76.3848 322.112 76.0867C323.293 75.4331 324.318 75.0316 325.19 74.8824C326.112 74.7274 326.857 74.6184 327.425 74.5552C329.539 74.3197 331.141 74.6374 332.23 75.5082C332.649 75.9838 333.053 76.5654 333.443 77.253Z",
    fill: "black"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_bd_2706_16877)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2706_16877)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.7305,
    y: 183,
    width: 166.673,
    height: 48.9314,
    rx: 15.2911,
    transform: "rotate(7.40986 13.7305 183)",
    fill: "white",
    fillOpacity: 0.7,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.7246,
    cy: 209.859,
    r: 8.41009,
    transform: "rotate(7.40986 33.7246 209.859)",
    fill: "#7C4DFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5813,
    cy: 213.375,
    r: 8.41009,
    transform: "rotate(7.40986 57.5813 213.375)",
    fill: "#3D5AFE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.7309,
    cy: 215.972,
    r: 8.41009,
    transform: "rotate(7.40986 80.7309 215.972)",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.234,
    cy: 219.028,
    r: 8.41009,
    transform: "rotate(7.40986 104.234 219.028)",
    fill: "#E040FB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.737,
    cy: 222.085,
    r: 8.41009,
    transform: "rotate(7.40986 127.737 222.085)",
    fill: "#FF4081"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.241,
    cy: 225.142,
    r: 8.02781,
    transform: "rotate(7.40986 151.241 225.142)",
    fill: "white",
    fillOpacity: 0.37,
    stroke: "#607D8B",
    strokeWidth: 0.764554
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.183 225.158L155.007 226.045",
    stroke: "#607D8B",
    strokeWidth: 0.860123,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.151 229.013L152.039 222.19",
    stroke: "#607D8B",
    strokeWidth: 0.860123,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2706_16877",
    x: 53.3602,
    y: 90.4701,
    width: 267.65,
    height: 110.058,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.52988
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.52988
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.160784 0 0 0 0 0.47451 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2706_16877"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2706_16877",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2706_16877",
    x: 59.0477,
    y: 95.6278,
    width: 63.7857,
    height: 66.8357,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10.6749,
    dy: 13.7249
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.95621
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2706_16877"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2706_16877",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_2706_16877",
    x: 242.08,
    y: 36.0734,
    width: 124.68,
    height: 120.081,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 3.28461
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2706_16877"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -14.7807,
    dy: 11.4961
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.21151
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_2706_16877",
    result: "effect2_dropShadow_2706_16877"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_2706_16877",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bd_2706_16877",
    x: -13.223,
    y: 162.357,
    width: 212.877,
    height: 111.304,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 10.3215
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2706_16877"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.35187
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.20504
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_2706_16877",
    result: "effect2_dropShadow_2706_16877"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_2706_16877",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2706_16877"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.7305,
    y: 183,
    width: 166.673,
    height: 48.9314,
    rx: 15.2911,
    transform: "rotate(7.40986 13.7305 183)",
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyState);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "empty-state.f012c8397717afef3ccb3228d62d7a29.svg";